import api from "../api/api";
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const clienteService = {



  IncluirCliente: async (cliente) => {
    try {
      const url = `${BASE_URL}/clientes`;
      const response = await api.post(url, cliente);
      return response.data;
    } catch (error) {
      console.error("Erro ao incluir Ciente:", error);
      throw new Error("Erro ao incluir Ciente.");
    }
  },

  obterTodos: async (params) => {
    try {
      const url = `${BASE_URL}/clientes-lista`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter clientes:", error);
      throw new Error("Erro ao obter clientes.");
    }
  },

  obterPorId: async (id) => {
    try {
      const response = await api.get(
        `https://api.tabosasistemas.com.br/api/clientes/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao obter cliente por id", error);
      throw error;
    }
  },

  // ... Outros métodos, como criar, atualizar, deletar, etc., também devem seguir essa estrutura.
};
